import { connect } from 'react-redux';
import {
    clearAll,
    getImpressionStats,
    groupStatsBy,
    setSelectedGraphKeys,
    setFormField,
} from '../../reduxStore/config/impressionstats';
import ImpressionStatsWrapper from './ImpressionStatsWrapper';
import mapProductSummaryToTable from '../../utils/tableAdapter/genericTableAdapter';
import mapStatsToLineChart from '../../utils/chartAdapter/lineChartAdapter';
import {
    mapSourceToDoughnutGraph,
    mapPageToDoughnutGraph,
    mapCustomerToDoughnutGraph,
} from '../../utils/chartAdapter/doughnutChartAdapter';

const mapStateToProps = (state, ownProps) => {
    const {
        groupBy,
        formState,
        stats,
        graphDataPoint,
        graphDate,
        selectedGraphKeys,
    } = state.impressionstats;

    const {
        user,
        preferedLanguage,
    } = state.user;

    const {
        totalImpressionCount,
        totalImpressionCountCustomer,
        sourceSummary,
        pageSummary,
        paidProductSummary,
    } = stats;

    const {
        translation,
    } = ownProps;

    const graphKeys = graphDataPoint ? Object.keys(graphDataPoint)
        .map((product, index) => (
            {
                id: index,
                text: translation.PRODUCT_KEYS[product] || product,
                isDefault: product === 'total',
            }
        ))
        : [];

    const preSelectedGraphKeys = selectedGraphKeys || graphKeys.filter(key => key.isDefault);

    return {
        graphData: graphDataPoint && graphDate ? mapStatsToLineChart(
            graphDataPoint,
            graphDate,
            groupBy,
            translation,
        ) : null,

        graphKeys,

        preSelectedGraphKeys,

        tableData: paidProductSummary && totalImpressionCount ? mapProductSummaryToTable(
            paidProductSummary,
            totalImpressionCount,
            translation,
        ) : null,

        totalCount: totalImpressionCount,
        totalCountString: totalImpressionCount ? totalImpressionCount.toLocaleString('sv-se') : null,

        translation,
        groupBy,
        formState,
        userLocale: preferedLanguage,
        isAnalyzeUser: user ? user.isAnalyzeUser : null,

        sourceData: sourceSummary && totalImpressionCount ? mapSourceToDoughnutGraph(
            sourceSummary,
            totalImpressionCount,
            translation,
        ) : null,

        pageData: pageSummary && totalImpressionCount ? mapPageToDoughnutGraph(
            pageSummary,
            totalImpressionCount,
            translation,
        ) : null,

        customerData: totalImpressionCountCustomer
            && totalImpressionCount
            ? mapCustomerToDoughnutGraph(
                totalImpressionCountCustomer,
                totalImpressionCount,
                translation,
            ) : null,

        leadOriginData: null,
    };
};

const mapDispatchToProps = dispatch => ({
    handleClear: () => {
        dispatch(clearAll());
    },
    handleSubmit: (formData) => {
        dispatch(getImpressionStats(formData));
    },
    handleGroupBy: (groupBy) => {
        dispatch(groupStatsBy(groupBy));
    },
    handleSelectGraphKeys: (selected) => {
        dispatch(setSelectedGraphKeys(selected));
    },
    handleUpdateFormField: (field) => {
        dispatch(setFormField(field));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(ImpressionStatsWrapper);
